import React, { useEffect } from 'react';

const Login: React.FC = () => {
  useEffect(() => {
    // Redirect to the login route handled by APISIX
    window.location.href = 'http://localhost:9080/auth/login'; // This sends the request to the server
  }, []);

  return <div>Redirecting to login...</div>;
};

export default Login;
